// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"5f5c9169","210":"8bbd51bb","519":"03d31317","609":"2b96ee1c","930":"db229250"}[chunkId] + ".chunk.js";
};